import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import drawer from '../../../Assets/Announcement//images/arrow-up.svg';
import downarrow from '../../../Assets/Announcement/Assets-Desktop/arrow_down.svg';
import '../../../css/ContainerStatus/ContainerStatus.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import DropDownTable from '../../Shared/DropDownTable';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import { useDispatch, useSelector } from 'react-redux';
import { success } from '../../../Redux/_actions/container.actions';

const ContainerStatus = props => {
    // for user type redux state
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    let history = useHistory();
    const dispatch = useDispatch();
    const containerDataR = useSelector(state => state.containerReducer.data);
    const [terminalDropdown, setTerminalDropdown] = useState(false);
    const container = React.createRef();
    const [terminal, setTerminal] = useState(containerDataR?.containerTerminalNameLS);
    const [containerNo, setContainerNo] = useState(containerDataR?.containerNumberLS);
    const [lading, setLading] = useState(containerDataR?.billOfLadingNumberLS);
    let [terminalError, setTerminalError] = useState();
    let [containerNoError, setContainerNoError] = useState();
    let [ladingError, setLadingError] = useState();
    let [containerError, setContainerError] = useState();
    const userPremium = manageProfileDataR?.tileUserType;

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        if (lading) {
            setContainerNo('');
        }
        if (userPremium == "Premium") {
            if (containerNo) {
                setLading('');
            }
        }
    });
    const handleClickOutside = event => {
        if (container.current && !container.current.contains(event.target)) {
            setTerminalDropdown(false);
        }
    };
    const data = [
        {
            id: 1,
            name: "All Terminals"
        },
        {
            id: 2,
            name: "Cape Town Container Terminal"
        },
        {
            id: 3,
            name: "Durban Pier One Container Terminal"
        },
        {
            id: 4,
            name: "Durban Pier Two Container Terminal"
        },
        {
            id: 5,
            name: "Durban Point Terminal"
        }
        ,
        {
            id: 6,
            name: "East London Multi-Purpose Terminal"
        }
        ,
        {
            id: 7,
            name: "Ngqura Container Terminal"
        }
        ,
        {
            id: 8,
            name: "Port Elizabeth Container Terminal"
        }
    ];
    const toggleTerminalDropdown = () => {
        setTerminalDropdown(!terminalDropdown);
    };
    const handleChangeContainerNo = (e) => {
        setContainerNo(e.target.value);
        setContainerNoError();
        document.getElementById('vs06123').style.borderColor = ColorCode.colorCode.black;
        if (userPremium == "Premium") {
            setContainerError();
            setLading('');
            document.getElementById('container').style.borderColor = ColorCode.colorCode.black;

        }
    }
    const handleChangeLading = (e) => {
        setLading(e.target.value);
        setLadingError();
        document.getElementById('vs061234').style.borderColor = ColorCode.colorCode.black;
        if (userPremium == "Premium") {
            setContainerError();
            setContainerNo('');
            document.getElementById('container').style.borderColor = ColorCode.colorCode.black;

        }
    }
    const validate = () => {
        let isValid = true;
        if (!terminal) {
            isValid = false;
            terminalError = Message.validation.required;
            document.getElementById('vs06').style.borderColor = ColorCode.colorCode.red;
        }
        if (userPremium == "Premium") {
            if (!containerNo && !lading) {
                isValid = false;
                containerError = Message.validation.required;
                document.getElementById('container').style.borderColor = ColorCode.colorCode.red;
            }
        }
        if (userPremium == "Preview") {
            if (!containerNo) {
                isValid = false;
                containerNoError = Message.validation.required;
                document.getElementById('vs06123').style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementById('vs06123').style.borderColor = ColorCode.colorCode.black;
            }
        }
        setTerminalError(terminalError);
        setContainerNoError(containerNoError);
        setLadingError(ladingError);
        setContainerError(containerError);
        return isValid;
    }
    const submitContainer = () => {
        if (validate()) {
            if (containerNo) {
                const containerData = {
                    containerNumberLS: containerNo,
                    billOfLadingNumberLS: '',
                    containerTerminalNameLS: terminal,
                }
                dispatch(success(containerData));
                history.push({
                    pathname: `/containerTrip/${containerNo}`,
                });
            }
            if (lading) {
                const containerData = {
                    containerNumberLS: '',
                    billOfLadingNumberLS: lading,
                    containerTerminalNameLS: terminal,
                }
                dispatch(success(containerData));
                history.push({
                    pathname: `/billOfLading/${lading}`,
                });
            }
        }
    };
    const changeTerminal = (event) => {
        data?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        setTerminal(event.target.innerText);
        setTerminalError();
        document.getElementById('vs06').style.borderColor = ColorCode.colorCode.black;
        setTerminalDropdown(false);
    }
    const eye = terminalDropdown ? <img src={drawer} /> : <img src={downarrow} />
    return (
        <div>
            <div class="cssouter11">
                <MetaDecorator title={TitleDescription.containerStatusPageTitle} description={TitleDescription.containerStatusPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="midDiv" id="cssvsbox1" >
                    <div class="vupNav">
                        <div class="vs01">
                            <small class="" id="vcccc">Container Status </small>
                        </div>
                    </div>
                    <hr class="hr1" />
                    <div class="vesselrow2">
                        <div></div>
                        <div class="vs02">
                            <div class="vs03" >
                                <small class="p-1" id="" class="vs04" >Terminal </small>
                            </div>
                            <div class="vs05" >
                                <div className="pass-wrapper" id="vs07" >
                                    <input readOnly class="form-control form-control-sm outline4" placeholder="Select Terminal" type="text" id="vs06" value={terminal} ></input>
                                    <i id="vesselinput_img" onClick={toggleTerminalDropdown}>{eye}</i>
                                </div>
                                <div className="vesselerror">{terminalError}</div>
                                {terminalDropdown && (
                                    <div class="vessel08" >
                                        <div class="vsdropdowncard" ref={container}>
                                            {(data?.map((name, index) => {
                                                return (
                                                    <DropDownTable onClick={changeTerminal} >
                                                        <small id="tt2" >{name?.name} </small>
                                                    </DropDownTable>
                                                );
                                            }))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div class="vs10" >
                            <div class="vs03" >
                                <small class="p-1" id="vs044" >Track Container </small>
                            </div>
                            <div class="vs05123" id="container">
                                <div className="pass-wrapper" >
                                    {userPremium == "Premium" ?
                                        <div id="vs07right">
                                            <div>
                                                <input class="form-control form-control-sm outline4" placeholder="Enter Container No" type="text" id="vs06123" value={containerNo}
                                                    onChange={handleChangeContainerNo} ></input>
                                                <div className="vesselerror1">{containerNoError}</div>
                                            </div>
                                            <small class="p-1" id="or" >OR </small>
                                            <input class="form-control form-control-sm outline4" placeholder="Enter Bill of Lading" type="text" id="vs061234" value={lading}
                                                onChange={handleChangeLading} ></input>
                                            <div className="vesselerror1">{ladingError}</div>
                                            <div className="vesselerror1">{containerError}</div>
                                        </div>
                                        :
                                        <div id="vs07rightuppart">
                                            <input class="form-control form-control-sm outline4" placeholder="Enter Container No" type="text" id="vs06123" value={containerNo}
                                                onChange={handleChangeContainerNo} ></input>
                                            <div className="vesselerror1uppart">{containerNoError}</div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cssvbutt1">
                        <Button class="butt" onClick={submitContainer}>
                            <small class="bt01"> Continue</small>
                        </Button>
                    </div>
                </div>
                <div class="cssfooter22">
                    <Footer2 />
                </div>
            </div>
            <div class="cssfooter11">
                <Footer />
            </div>
        </div>
    );
}
export default ContainerStatus;
